import React from 'react';
import { RequestForm } from '~/src/components/RequestForm';
import * as ST from './styled';

interface IProps {
    sendRequest: () => void,
    title: string,
    desc: string,
    isLoading: boolean,
}

export const CallBackForm = ({ sendRequest, title, desc, isLoading }: IProps) => {
    return (
        <ST.FormContainer>
            <ST.FormText>
                <ST.FormTitle>{title}</ST.FormTitle>
                <ST.FormDesc>{desc}</ST.FormDesc>
            </ST.FormText>
            <ST.FormRight>
                <RequestForm
                    submitRequest={sendRequest}
                    isLoading={isLoading}
                />
            </ST.FormRight>
        </ST.FormContainer>
    );
};
